<template>
  <div class="titlePwa">
      <!-- 標題 -->
      <h2 class="global-title" v-html="textTitle"></h2> 
      <!-- 按鈕(前往) -->
      <div v-if="showMore" class="moreBtn" @click="handleClickMore" >
          <span class="icon-circle-right"></span>{{ textMore }}
      </div>
  </div>
</template>
<script>
export default {
  name: "PwaTitle",
  props: {

    textTitle: {   
      type: String,
      default: ""
    },
    showMore: {   
      type: Boolean,
      default: true
    },
    textMore: {       // 父層傳進來的說明文字
      type: String,
      default: ""
    }
  },
  methods: {
    handleClickMore() {
      //alert("子層內建事件");
      this.$emit("clickMore"); // 再通知父層
    }
  }  
};
</script>
